module.exports = __webpack_public_path__ + "static/media/icons8-jenkins.5c507e04.svg";